import {
  GET_DISCOVERY_PROVINCES,
  GET_DISCOVERY_PROVINCE_DETAILS,
  GET_DISCOVERY_PROVINCE_DETAILS_FAILED,
  GET_DISCOVERY_PROVINCE_DETAILS_SUCCESS,
  GET_DISCOVERY_PROVINCES_FAILED,
  GET_DISCOVERY_PROVINCES_SUCCESS,
  CLEANUP_DISCOVER_PROVINCE_DETAILS,
  CLEANUP_PROVINCES_NAME,
  GET_PROVINCES_NAME,
  GET_PROVINCES_NAME_SUCCESS,
  GET_PROVINCES_NAME_FAILED,
  CLEANUP_DISCOVERY_PROVINCES,
} from './actionTypes';

const initialState = {
  provinces: { data: [], total: 0 },
  provincesLoading: true,

  provinceDetails: {},
  provinceDetailsLoading: true,

  provincesName: [],
  provincesNameLoading: true,
};

export default function discoverProvince(state = initialState, action) {
  switch (action.type) {
    // GET_DISCOVERY_PROVINCE_DETAILS
    case GET_DISCOVERY_PROVINCE_DETAILS:
      return {
        ...state,
        provinceDetailsLoading: true,
      };

    case GET_DISCOVERY_PROVINCE_DETAILS_SUCCESS:
      return {
        ...state,
        provinceDetailsLoading: false,
        provinceDetails: action.payload,
      };

    case GET_DISCOVERY_PROVINCE_DETAILS_FAILED:
      return {
        ...state,
        provinceDetailsLoading: false,
      };

    case CLEANUP_DISCOVER_PROVINCE_DETAILS:
      return {
        ...state,
        provinceDetailsLoading: true,
        provinceDetails: {},
      };

    // GET_DISCOVERY_PROVINCES
    case GET_DISCOVERY_PROVINCES:
      return {
        ...state,
        provincesLoading: true,
      };

    case GET_DISCOVERY_PROVINCES_SUCCESS:
      return {
        ...state,
        provincesLoading: false,
        provinces: action.payload,
      };

    case GET_DISCOVERY_PROVINCES_FAILED:
      return {
        ...state,
        provincesLoading: false,
      };

    case CLEANUP_DISCOVERY_PROVINCES:
      return {
        ...state,
        provincesLoading: true,
        provinces: { data: [], total: 0 },
      };

    // GET_PROVINCES_NAME
    case GET_PROVINCES_NAME:
      return {
        ...state,
        provincesNameLoading: true,
      };

    case GET_PROVINCES_NAME_SUCCESS:
      return {
        ...state,
        provincesNameLoading: false,
        provincesName: action.payload,
      };

    case GET_PROVINCES_NAME_FAILED:
      return {
        ...state,
        provincesNameLoading: false,
      };

    case CLEANUP_PROVINCES_NAME:
      return {
        ...state,
        provincesNameLoading: true,
        provincesName: [],
      };

    default: return state;
  }
}
